<template>
  <v-row align="center" no-gutters class="entity-header-v2">
    <slot name="icon">
      <icon :type="icon" v-if="icon" />
    </slot>
    <v-col class="entity-header-v2__content d-flex flex-column flex-md-row align-start align-md-center">
      <h1
        class="entity-header-v2__name headline primary--text text-truncate"
        :class="{ 'ml-2': hasIcon }"
        data-testid="entity-name"
      >
        <slot />
      </h1>
      <span
        class="entity-header-v2__details ml-2 mt-1 mt-md-0 flex-shrink-0 text-truncate"
        v-if="details"
        data-testid="entity-details"
      >{{ details }}</span>
    </v-col>
  </v-row>
</template>

<script>
import Icon from '@/components/Icon';

export default {
  name: 'entity-header-v2',
  components: {
    Icon,
  },
  props: {
    icon: {
      type: String,
      required: false,
    },
    details: {
      type: String,
      required: false,
    },
  },
  computed: {
    hasIcon() {
      return this.icon != null || !!this.$slots.icon;
    },
  },
};
</script>

<style lang="sass" scoped>
.entity-header-v2
  overflow: hidden
  max-width: 100%

.entity-header-v2__content
  min-width: 0
  overflow: hidden

.entity-header-v2__name
  min-width: 0
  flex: 1
  max-width: 100%

.entity-header-v2__details
  @media (max-width: 959px)
    align-self: stretch
</style>
